module.exports = __webpack_public_path__ + "static/bg-showcase-3-91db0751f17876aac87e28a2033e3e76.jpg";